// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__IfA1w","footerContent":"footer_footerContent__pSQW2","socialIcons":"footer_socialIcons__wq2Mq"};